/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2021
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
//@import BaseMoserObject (loadtime) // superclass

/**
 * Place holder for the latest module version.
 */
export default class ModuleVersion extends BaseMoserObject{

	/**
	 * This value is generated from Module.version's annotation.
	 */
	static LATEST_VERSION = "11.1";


}


// WEBPACK FOOTER //
// ./src/generated/ModuleVersion.js